import React from 'react'
import { Stack } from '@mui/material'
import { useLocation } from 'react-router-dom'
import NoticesSectionsContainer from './NoticesSectionsContainer'
import { useNoticesContext } from './NoticesContext'

export default function PageNoticesContainer() {
    const { notices, noticesRef } = useNoticesContext()
    const location = useLocation()

    if (notices == null) {
        return null
    }

    const routeNotices = notices.filter((notice) => notice.route === location.pathname)

    return (
        <Stack
            ref={noticesRef}
            direction="column"
            gap={1}
        >
            <NoticesSectionsContainer notices={routeNotices} />
        </Stack>
    )
}
